// extracted by mini-css-extract-plugin
module.exports = {"tileWH":"9%","tileContainerWH":"12%","tileContainerLengthMobile":"16%","gameBoard":"Plastic3Match_gameBoard__3BJdo"};